import { render, staticRenderFns } from "./SimulatorNotification.vue?vue&type=template&id=6931b240&scoped=true&"
import script from "./SimulatorNotification.vue?vue&type=script&lang=js&"
export * from "./SimulatorNotification.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorNotification.vue?vue&type=style&index=0&id=6931b240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6931b240",
  null
  
)

export default component.exports